import { useMediaThematicBlockSetToCompanyMutation } from '@shared/api/graphql/generated';

const useCompanyThematicBlockSet = () => {
  const [mutation, data] = useMediaThematicBlockSetToCompanyMutation();

  const request = async (
    startDate: string,
    endDate: string,
    companyId: string,
    thematicBlockId: string,
    streamsIds: string[] | null
  ) => {
    const mutationResult = await mutation({
      variables: {
        input: {
          startDate,
          endDate,
          companyId,
          thematicBlockId,
          streamsIds,
        },
      },
    });
    return !!mutationResult.data?.result?.ok;
  };

  return {
    request,
    error: data.error,
    loading: data.loading,
  };
};

export default useCompanyThematicBlockSet;
